'use strict';

var Field = require('./Field');

angular.module('dekky.forms.fields.mountainAreaSelect', [])
.factory('MountainAreaSelectField', function($timeout, $rootScope) {
	function mountainAreaSelectFactory(name, options, items) {
		function MountainAreaSelect(name, options, items) {
			if (!Array.isArray(items)) {
				throw new Error('Not items for select');
			}

			var that = this;
			this.type = 'mountainAreaSelect';
			this.items = items;
			this.selectedRegion = null;
			this.mountainAreas = [];
			this.model = null;

			var modelWatch = $rootScope.$watch(function() {
				return that.model;
			}, function(newVal, oldVal) {
				if (newVal && !oldVal) {
					$timeout(function() {
						that.selectedRegion = newVal.mountain_region;
						var regionsWatch = $rootScope.$watch(function() {
							return that.items.length;
						}, function(newVal) {
							if (newVal > 0) {
								that.changeRegion();
								regionsWatch();
								modelWatch();
							}
						});
					});
				}
			});

			Field.apply(this, arguments);
		}

		MountainAreaSelect.prototype = Object.create(Field.prototype);
		MountainAreaSelect.prototype.changeRegion = function() {
			var that = this;
			$timeout(function() {
				if (that.selectedRegion) {
					that.items.forEach(function(region) {
						if (region.id == that.selectedRegion.id) {
							that.mountainAreas = region.mountain_areas;
						}
					})
				}
			});
		};

		return new MountainAreaSelect(name, options, items);
	}

	return mountainAreaSelectFactory;
});